import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { get } from 'lodash-es';

import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { ButtonContainer } from 'components/button/button-container';
import { Button } from '../button';
import { Field, Form, reduxForm, reset } from 'redux-form';
import { reportVideoAction } from 'common/actions';
import { REPORT_VIDEO_DIALOG } from 'components/report-video';
import { dialogSelector } from 'components/redux-dialog/selectors';

const mapDispatchToProps = (dispatch, props) => ({
  hideDialog: () => {
    dispatch(hideDialogAction(REPORT_VIDEO_DIALOG));

    dispatch(reset(props.form));
  },
  reportVideo: (video, message, url) => {
    dispatch(reportVideoAction(video.id, message, url));

    dispatch(reset(props.form));
  },
});

const mapStateToProps = (state) => ({
  dialog: dialogSelector(state)(REPORT_VIDEO_DIALOG),
});

let ProtectedReportDialog = class extends React.Component {
  submitHandler = (values) => {
    this.props.reportVideo(get(this.props.dialog, 'data.video'), values.message, window.location.href);
  };

  render() {
    const { handleSubmit, hideDialog, pristine, submitting, invalid, t } = this.props;

    return (
      <DialogDecorated dialogName={REPORT_VIDEO_DIALOG}>
        <DialogTitle>
          <h2>{t('report_video')}</h2>
        </DialogTitle>
        <Form onSubmit={handleSubmit(this.submitHandler)}>
          <DialogBody>
            <div>
              <div className="report-description">{t('describe_report_of_video')}</div>
              <div className="message">{t('message')} *</div>
              <Field className="form-control" name="message" component="textarea" maxLength="1000" rows="4" />
            </div>
          </DialogBody>
          <DialogFooter>
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-5 col-sm-5 col-xs-12 mandatory-field">
                <div>* {t('mandatory_field')}</div>
              </div>
              <div className="col-xl-8 col-lg-8 col-md-7 col-sm-7 col-xs-12 report-video-buttons">
                <ButtonContainer>
                  <Button onClick={() => hideDialog()} secondary={true}>
                    {t('cancel')}
                  </Button>
                  <Button type={'submit'} disabled={pristine || submitting || invalid}>
                    {t('send')}
                  </Button>
                </ButtonContainer>
              </div>
            </div>
          </DialogFooter>
        </Form>
      </DialogDecorated>
    );
  }
};

ProtectedReportDialog = compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(ProtectedReportDialog);

ProtectedReportDialog = reduxForm({
  form: 'reportVideoForm',
})(ProtectedReportDialog);

export { ProtectedReportDialog };
